// Simple modifier utilities
export const filterEnabledModifiers = (modifiers: any[] = []): any[] => {
  return modifiers
    .filter(modifier => 
      modifier.options && modifier.options.some((option: any) => option.isEnabled === true)
    )
    .map(modifier => ({
      ...modifier,
      options: modifier.options.filter((option: any) => option.isEnabled === true)
    }));
};

export const isModifierRequired = (modifier: any): boolean => {
  return modifier.is_forced?.toLowerCase() === 'yes' || modifier.is_forced?.toLowerCase() === 'no';
};

export const isModifierMultiSelect = (modifier: any): boolean => {
  return modifier.is_multi_select?.toLowerCase() === 'yes';
};

export const isModifierOptionSelected = (
  modifierName: string,
  optionName: string,
  selectedModifiers: any[]
): boolean => {
  const modifier = selectedModifiers.find(mod => mod.name === modifierName);
  return modifier ? modifier.options.some((opt: any) => opt.name === optionName) : false;
};

export const handleModifierOptionSelection = (
  modifierName: string,
  option: any,
  selectedModifiers: any[],
  modifiersList: any[]
): any[] => {
  const existingModifierIndex = selectedModifiers.findIndex(mod => mod.name === modifierName);
  const modifier = modifiersList.find(mod => mod.name === modifierName);
  const isMultiSelect = isModifierMultiSelect(modifier);

  if (existingModifierIndex >= 0) {
    const existingModifier = selectedModifiers[existingModifierIndex];
    
    if (isMultiSelect) {
      const optionExists = existingModifier.options.some((opt: any) => opt.name === option.name);
      
      if (optionExists) {
        // Remove option if already selected
        const updatedOptions = existingModifier.options.filter((opt: any) => opt.name !== option.name);
        if (updatedOptions.length === 0) {
          return selectedModifiers.filter((_, index) => index !== existingModifierIndex);
        } else {
          const newModifiers = [...selectedModifiers];
          newModifiers[existingModifierIndex] = { ...existingModifier, options: updatedOptions };
          return newModifiers;
        }
      } else {
        // Add option (no maxSelection validation here)
        const newModifiers = [...selectedModifiers];
        newModifiers[existingModifierIndex] = {
          ...existingModifier,
          options: [...existingModifier.options, option]
        };
        return newModifiers;
      }
    } else {
      // Single select - replace
      const newModifiers = [...selectedModifiers];
      newModifiers[existingModifierIndex] = { name: modifierName, options: [option] };
      return newModifiers;
    }
  } else {
    return [...selectedModifiers, { name: modifierName, options: [option] }];
  }
};

// Additional reusable modifier utilities
export const hasEnabledOptions = (modifier: any): boolean => {
  return modifier.options && modifier.options.some((option: any) => option.isEnabled === true);
};

export const getModifierValidationMessage = (modifierName: string): string => {
  return `Please select a ${modifierName.toLowerCase()}`;
};

export const getSelectedModifierOptions = (modifierName: string, selectedModifiers: any[]): any[] => {
  const modifier = selectedModifiers.find(mod => mod.name === modifierName);
  return modifier ? modifier.options : [];
};

export const hasModifierSelection = (modifierName: string, selectedModifiers: any[]): boolean => {
  const modifier = selectedModifiers.find(mod => mod.name === modifierName);
  return modifier && modifier.options.length > 0;
};

export const hasModifierForcedStatus = (modifier: any): boolean => {
  return Boolean(modifier.is_forced);
};
